const ColorPreviewBox = (
  {
    selectedColorRGB,
    className,
  }
) => {
  const selectedColorBackgroundCSS = selectedColorRGB
    ? {
      backgroundColor: `rgb(${selectedColorRGB.join(', ')})`
    }
    : {
      backgroundColor: `#eee`,
      backgroundImage: 'linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(-45deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%), linear-gradient(-45deg, transparent 75%, #ccc 75%)',
      backgroundSize: '20px 20px',
      backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px'
    };
  return <div
    className={className}
    style={{aspectRatio: '16 / 9', ...selectedColorBackgroundCSS, border: '1px solid #000000'}}
  />
}

export default ColorPreviewBox;